import { Anchor, Paper, SimpleGrid, Stack, Text } from '@mantine/core';

export interface JobsCountersWidgetProps {
  myJobsCount: number;
  allJobsCount: number;
  myJobsUrl: string;
  allJobsUrl: string;
}

interface CounterCardProps {
  label: string;
  count: number;
  caption: string;
  href: string;
}

const counterCardStyles = {
  root: {
    border: '1px solid transparent',
    background:
      'linear-gradient(var(--white), var(--white)) padding-box, linear-gradient(180deg, var(--yellow), #f49a0a) border-box',
  },
};

function CounterCard({ label, count, caption, href }: CounterCardProps) {
  return (
    <Anchor
      href={href}
      underline="never"
      c="inherit"
      display="block"
      h="100%"
      style={{ cursor: 'pointer' }}
    >
      <Paper
        shadow="var(--widget-shadow)"
        p="lg"
        h="100%"
        styles={counterCardStyles}
      >
        <Stack gap={6}>
          <Text fw={700} fz="lg">
            {label}
          </Text>
          <Text fw={800} fz={42} lh={1}>
            {count.toLocaleString('en-US')}
          </Text>
          <Text fw={600} c="dimmed">
            {caption}
          </Text>
        </Stack>
      </Paper>
    </Anchor>
  );
}

export function JobsCountersWidget({
  myJobsCount,
  allJobsCount,
  myJobsUrl,
  allJobsUrl,
}: JobsCountersWidgetProps) {
  return (
    <SimpleGrid cols={2} spacing="md">
      <CounterCard
        label="My Jobs"
        count={myJobsCount}
        caption="find and apply to local event jobs you want!"
        href={myJobsUrl}
      />
      <CounterCard
        label="All Jobs"
        count={allJobsCount}
        caption="find and apply to all jobs on TH!"
        href={allJobsUrl}
      />
    </SimpleGrid>
  );
}

export default JobsCountersWidget;
